import { createAsyncTypes } from '../utils';

// export const DOCUMENTS = createAsyncTypes('DOCUMENTS');
export const BUY_PDF_DOCUMENT = createAsyncTypes('BUY_PDF_DOCUMENT');
export const ORDER_PDF_DOCUMENT = createAsyncTypes('ORDER_PDF_DOCUMENT');

export const FETCH_CLAIM_DOCUMENTS = createAsyncTypes('FETCH_CLAIM_DOCUMENTS');
// export const DOCKETS_POPUP = 'DOCKETS_POPUP';
export const UPDATE_CLAIMS_PARTS = 'UPDATE_CLAIMS_PARTS';
export const RESET_CLAIMS_PARTS = 'RESET_CLAIMS_PARTS';
export const DOCKETS_FAVORITE_EMAIL = 'DOCKETS_FAVORITE_EMAIL';
export const UPDATE_DOCKET_HEADER = 'UPDATE_DOCKET_HEADER';
export const UPDATE_DOCKET_DETAILS = 'UPDATE_DOCKET_DETAILS';
export const UPDATE_REDACT = 'UPDATE_REDACT';
export const UPDATE_CLAIMS = 'UPDATE_CLAIMS';
export const UPDATE_SELECTED_CLAIM = 'UPDATE_SELECTED_CLAIM';
export const UPDATE_CLAIM_DOCUMENT = 'UPDATE_CLAIM_DOCUMENT';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/claimDocumentsActionTypes.js